export default {"src":"/_next/static/media/Powerlytics.677eec81.svg","height":48,"width":39};